import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {required} from '@app/shared/validators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy'
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {AUTH_SERVICE, AuthService} from "@atl/lacerta-ui-common";

declare global {
    interface Window { process: any; }
}

@UntilDestroy()
@Component({
    selector: 'lta-login-screen',
    templateUrl: 'login-screen.component.html',
    styleUrls: ['login-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginScreenComponent implements OnInit {
    loginForm: FormGroup;
    error$: Observable<string> = this.authService.error$;
    isLoading: boolean = false;
    isLoggedIn: boolean = false;
    readonly entryWindowTypes = [
        {
            value: 0,
            name: this.translateService.get('lta-login.local')
        },
        {
            value: 1,
            name: 'LDAP'
        },
        {
            value: 2,
            name: 'Keycloak'
        },
    ];

    preconfiguredServer: string = this.getCurrentPreconfiguredHost();
    isElectron = window.location.protocol === 'file:';

    constructor(
        private formBuilder: FormBuilder,
        @Inject(AUTH_SERVICE) private authService: AuthService,
        private translateService: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.loginForm = this.formBuilder.group({
            host: new FormControl(this.preconfiguredServer ?? '', this.isElectron ? [required] : []),
            login: new FormControl('', [required]),
            password: new FormControl('', [required]),
            type_entry_window: new FormControl(0)
        });
        this.loginForm.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(() => this.authService.clearValidationError())

    }

    submitForm() {
        this.isLoading = true;
        this.loginForm.disable()

        if (this.isElectron) {
            localStorage.setItem('server', this.loginForm.value.host);
        }

        this.authService.login(this.loginForm.value).subscribe(
            (user) => {
                this.loginForm.enable({emitEvent: false})
                this.isLoggedIn = !!user
                if (user === null) {
                    this.isLoading = false
                }
            }
        );
    }

    protected getCurrentPreconfiguredHost(): string {
        if (window.process && window.process.argv) {
            for (let arg of window.process.argv) {
                if (arg.startsWith('--host=')) {
                    return arg.replace('--host=', '');
                }
            }
        }
        return null;
    }
}
